export default "__VITE_ASSET__B$FOEjA0__"